import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export const rejectPendingShift = (shiftId: string | null) => {
  const newEndpoints = endpoints.scheduling.rejectPendingShift.replace('{shiftId}', shiftId || '');
  return http().get(newEndpoints);
};

export function useRejectPendingShift(shiftId: string | null, options?: any): UseQueryResult<any> {
  return useQuery({
    queryKey: ['rejectPendingShift', shiftId],
    queryFn: () => rejectPendingShift(shiftId),
    ...options,
  });
}
